import { getQuickBooksConnectors, useApiQuery } from '@hum/api';

// Note: rename this, this is not showing the visibility but rather downloading the file
export const useQuickBooksRawDataVisibility = (companyId: string) => {
  const { data: showQuickBooksRawData, isLoading } = useApiQuery(
    getQuickBooksConnectors,
    {
      params: { companyId: companyId },
    }
  );

  return { data: showQuickBooksRawData, loaded: !isLoading };
};
